import { benchmarkIsActive, benchmarkIncludedInWeightedWork } from '../../../../shared/models/benchmark-policy.model';
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, of, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DemoService } from '../../../../demo.service';
import { GlobalFunctionsService } from '../../../../services/global-functions.service';

@Component({
  selector: 'app-log-type-benchmark',
  templateUrl: './log-type-benchmark.component.html',
  styleUrls: ['./log-type-benchmark.component.scss']
})
export class LogTypeBenchmarkComponent implements OnInit, OnChanges, OnDestroy {
  readonly benchmarkIsActive = benchmarkIsActive;
  readonly weightedIncluded = benchmarkIncludedInWeightedWork;
  @Input() item_id?: number;
  @Input() log_type_benchmark_id?: number;
  @Input() item_data?: any;
  @Input() use_item_data = 'no';
  @Input() widget_size = 'full';
  @Input() show_buttons = 'yes';
  @Input() widget_title = '';
  model: any;
  loading = false;
  error = '';
  logTypes: any[] = [];
  userLevels: any[] = [];
  brandTypes: any[] = [];
  private lookups: Subscription;
  private request: Subscription;
  private routeSubscription: Subscription;

  constructor(private api: DemoService, private route: ActivatedRoute, public gfunc: GlobalFunctionsService) {}

  ngOnInit(): void {
    this.routeSubscription = this.route.paramMap.subscribe(() => this.load());
    this.lookups = forkJoin([
      this.api.getSystemLogTypes().pipe(catchError(() => of([]))),
      this.api.getUserLevels().pipe(catchError(() => of([]))),
      this.api.getBrandBrandTypes().pipe(catchError(() => of([])))
    ]).subscribe(([logTypes, userLevels, brandTypes]: any[]) => {
      this.logTypes = logTypes; this.userLevels = userLevels; this.brandTypes = brandTypes;
    });
  }
  ngOnChanges(): void { this.load(); }
  ngOnDestroy(): void { this.request?.unsubscribe(); this.routeSubscription?.unsubscribe(); this.lookups?.unsubscribe(); }
  get actionName(): string { return this.logTypes.find(row => row.log_type_id == this.model?.log_type_id)?.log_type_name || this.model?.log_type_name || 'Action'; }
  get userLevelName(): string { return this.model?.user_level == 0 ? 'Global' : this.userLevels.find(row => row.user_level_id == this.model?.user_level)?.name || this.model?.user_level; }
  get brandTypeName(): string { return this.model?.brand_type_id == 0 ? 'Global' : this.brandTypes.find(row => row.brand_type_id == this.model?.brand_type_id)?.brand_type_name || this.model?.brand_type_id; }
  private load(): void {
    this.request?.unsubscribe(); this.model = null; this.error = ''; this.loading = false;
    if (this.use_item_data === 'yes' && this.item_data) { this.model = Array.isArray(this.item_data) ? this.item_data[0] : this.item_data; return; }
    const id = this.item_id || this.log_type_benchmark_id || Number(this.route.snapshot.paramMap.get('log_type_benchmark_id'));
    if (!id) { this.error = 'No benchmark was selected.'; return; }
    this.loading = true;
    this.request = this.api.getSystemLogTypeBenchmark(id).subscribe({
      next: (rows: any[]) => { this.model = rows[0]; this.loading = false; if (!this.model) { this.error = 'Benchmark not found.'; } },
      error: () => { this.loading = false; this.error = 'The benchmark could not be loaded.'; }
    });
  }

}
